var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof HRM !== "undefined") return resolve();
	__webpack_require__.l("https://hrm.lamantcafe.com/remote/hrm/remoteEntry.js?v=1787662094589", (event) => {
		if(typeof HRM !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "HRM");
}).then(() => (HRM));